import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IStringAnyMap } from 'src/app/app.types';
import { ImpersonateService } from 'src/app/service/impersonate.service';
import { SessionService } from 'src/app/service/session.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'flow-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  // public $imperonate : BehaviorSubject<IStringAnyMap|null> = new BehaviorSubject<IStringAnyMap|null>(null);
  
  public sessionValidUntil : number = 0;
  public sessionRenew : boolean = false;

  public showImpoeonate : boolean = false;
  public showDemoRoles : boolean = false;
  public showUserData : boolean = false;

  public get impersonate() : IStringAnyMap|null {
    return this.impersonateSrv.$selected.getValue();
  }

  constructor(
    public sessionSrv : SessionService,
    public session : SessionService,
    public impersonateSrv : ImpersonateService
  ) {
    // subscribe to sessionValidUntil$ to get the seconds until the session is valid
    this.session.sessionValidUntil$.subscribe((valid : number) => this.sessionValidUntil = valid);
    this.session.sessionExpiredSoon$.subscribe((renew : boolean) => this.sessionRenew = renew);

    this.showDemoRoles = environment.demoRoles;
    this.showImpoeonate = environment.userImpersonate;
    this.showUserData = environment.userData;

  }

  signOut () {
    this.session.signOut().subscribe();
  }

  renew() {
    this.session.renew().subscribe();
  }

}
